module.exports = __webpack_public_path__ + "webfolder/assets/ebook/ytt-magazine/img/page-two_c@2x.aa9aa8a6.jpg";